import { APP_NAME } from '@en3/shared';
import { Link, NavLink } from 'react-router-dom';
import { MAIN_NAV_ITEMS, ROUTES } from '@/app/routes';
import { useAuthStatus, useAuthUser } from '@/api/hooks/useAuth';
import { cn } from '@/lib/cn';
import { ThemeToggle } from './ThemeToggle';
import { BottomNav } from './BottomNav';

/**
 * 顶栏：品牌 + 主导航（桌面端）+ 主题切换 + 登录入口。
 * 移动端整条导航交给底部导航，顶栏只留品牌与主题/账户。
 */
export function TopBar() {
  const status = useAuthStatus();
  const user = useAuthUser();

  return (
    <>
      <header className="sticky top-0 z-40 border-b bg-background/85 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-5xl items-center gap-3 px-4">
          <Link to={ROUTES.home} className="flex items-center gap-2 font-semibold">
            <span className="grid size-7 place-items-center rounded-md bg-primary text-sm text-primary-foreground">
              英
            </span>
            <span className="hidden sm:inline">{APP_NAME}</span>
            <span className="sm:hidden">大学英语三</span>
          </Link>

          <nav aria-label="主导航" className="ml-2 hidden items-center gap-1 md:flex">
            {MAIN_NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === ROUTES.home}
                className={({ isActive }) =>
                  cn(
                    'rounded-md px-2.5 py-1.5 text-sm transition-colors',
                    isActive ? 'bg-accent text-accent-foreground' : 'text-muted-foreground hover:text-foreground',
                  )
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2">
            <ThemeToggle />
            {status === 'authenticated' ? (
              <Link
                to={ROUTES.profile}
                className="rounded-md px-2.5 py-1.5 text-sm text-muted-foreground hover:text-foreground"
              >
                {user?.displayName ?? '我的'}
              </Link>
            ) : (
              <Link
                to={ROUTES.login}
                className="rounded-md bg-primary px-3 py-1.5 text-sm text-primary-foreground hover:opacity-90"
              >
                登录
              </Link>
            )}
          </div>
        </div>
      </header>

      <BottomNav />
    </>
  );
}
